var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_194_212)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.39066 4.09694C7.12816 2.35975 10.0157 2.35975 11.7532 4.09694C13.3157 5.65944 13.5469 8.15006 12.2625 9.94694L12.2282 9.99694C11.9063 10.4438 11.2813 10.5501 10.8344 10.2282C10.3844 9.90631 10.2782 9.28131 10.6 8.83444L10.6344 8.78444C11.35 7.78131 11.2375 6.40944 10.3657 5.53756C9.38441 4.55631 7.78754 4.55631 6.80316 5.53756L3.29691 9.04694C2.31222 10.0032 2.31222 11.6251 3.29691 12.6094C4.16566 13.4813 5.54066 13.5938 6.54066 12.8782L6.59066 12.8157C7.04066 12.5219 7.66566 12.6251 7.98441 13.0751C8.30629 13.5251 8.20316 14.1501 7.75316 14.4719L7.70316 14.5063C5.87816 15.7907 3.44379 15.5844 1.8816 14.0251C0.116941 12.2594 0.116941 9.39694 1.8816 7.63444L5.39066 4.09694ZM14.6094 11.8751C12.8438 13.6407 9.98441 13.6407 8.21879 11.8751C6.65629 10.3126 6.45316 7.85006 7.73754 6.05319L7.77191 6.00319C8.06566 5.55631 8.69066 5.45006 9.16566 5.77194C9.61566 6.06569 9.72191 6.69069 9.40003 7.16569L9.36566 7.21569C8.65004 8.19069 8.76254 9.59069 9.63441 10.4626C10.6157 11.4438 12.2125 11.4438 13.1969 10.4626L16.7032 6.95319C17.6875 5.96881 17.6875 4.34694 16.7032 3.39069C15.8344 2.51975 14.4594 2.406 13.4594 3.12194L13.4094 3.15631C12.9594 3.47819 12.3344 3.34694 12.0157 2.92444C11.6938 2.47506 11.7969 1.85037 12.2469 1.52944L12.2969 1.49444C14.0938 0.210405 16.5563 0.414124 18.1188 1.97631C19.8844 3.74069 19.8844 6.60319 18.1188 8.36569L14.6094 11.8751Z",
    fill: "#3FD645"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_194_212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg04);
export default __webpack_public_path__ + "static/media/04.d6645ed49d9ff26e548cc48a42776b77.svg";
export { ForwardRef as ReactComponent };